module.exports = __webpack_public_path__ + "static/media/diamond-2-small.8d055724.png";